import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CButton,
  CContainer,
  CRow,
  CCol,
  CCarousel,
  CCarouselIndicators,
  CCarouselInner,
  CCarouselItem,
  CCarouselControl,
} from '@coreui/react';
import { capitalize } from 'lodash';
import moment from 'moment';
import { saveAs } from 'file-saver';
import usePortal from 'react-useportal';
import { Job } from '../../../shared/models/jobs';

export interface ViewJobImagesModalProps {
  job: Job;
  show: boolean;
  close: () => void;
}

const ViewJobImagesModal = (props: ViewJobImagesModalProps) => {
  const { job, show, close} = props;
  const type = job.images?.length > 1 ? 'Images' : capitalize(job.images?.[0].type);
  const [activeIndex, setActiveIndex] = useState(0);

  const { Portal } = usePortal({
    bindTo: document && document.querySelector('body')
  });

  const download = (url: string) => () => {
    saveAs(url);
  };

  return <Portal>
    {
      show && <CModal className="mt-5 pt-5" show={ show } onClose={ close } closeOnBackdrop={ false }>
        <CModalHeader closeButton>View {type}</CModalHeader>
        <CModalBody>
          <CContainer>
            <CRow className="justify-content-center">
              <CCol sm={12}>
                <CCarousel activeIndex={activeIndex} onSlideChange={(index) => setActiveIndex(index)}>
                  <CCarouselIndicators/>
                  <CCarouselInner>
                  {
                    job?.images.map((image) => (
                      <CCarouselItem className="carousel-item-custom" key={image.url}>
                        <img className="d-block w-100" src={image.url} alt="slide 1"/>
                      </CCarouselItem>
                    ))
                  }
                  </CCarouselInner>
                  <CCarouselControl direction="prev"/>
                  <CCarouselControl direction="next"/>
                </CCarousel>
                {
                  job?.images?.[activeIndex]?.description && (
                    <span className="d-block text-center font-xl">
                      {job?.images?.[activeIndex]?.description}
                    </span>
                  )
                }
                <span className="d-block text-center">
                  { moment(job?.images?.[activeIndex]?.created).format('l LT') }
                </span>
                <CButton block color="primary" className="mt-2 bg-color-orange roundedBtn" onClick={ download(job?.images?.[activeIndex]?.url) }>Download</CButton>
              </CCol>
            </CRow>
          </CContainer>
        </CModalBody>
        <CModalFooter className="glympse-footer">
          <div className="glympse-btnWrapper">
            <CButton className="glympse-cancelBtn" color="light" shape="rounded-pill" variant="ghost" onClick={ close }>Close</CButton>
          </div>
        </CModalFooter>
      </CModal>
    }
  </Portal>;
};

export default ViewJobImagesModal;
